import s from "./Section.module.scss";
import { PropsWithChildren, ReactNode } from "react";
import cn from "classnames";
import { Container } from "@/components/layout/Container";
import Image from "next/legacy/image";
import { Heading } from "@/components/UI/typography/Heading";
import { upperFirst } from "lodash";

export type SectionProps = PropsWithChildren<{
  icon?: string;
  heading: ReactNode;
  subheading?:
    | ReactNode
    | {
        multiline: true;
        content: ReactNode;
      };
  headingFullwidth?: boolean;
  className?: string;
  gradient?: number | "cta" | null;
  divider?: boolean;
  buttons?: ReactNode;
  note?: ReactNode;
  direction?: "vertical" | "horizontal";
  align?: "center" | "top";
  last?: boolean;
  subheadingCols?: boolean;
}>;
export const Section = ({
  heading,
  subheading,
  icon,
  className,
  gradient,
  children,
  divider,
  buttons,
  direction = "vertical",
  last,
  note,
  headingFullwidth,
  align = "center",
  subheadingCols,
}: SectionProps) => (
  <section
    className={cn(
      s.section,
      {
        [s.withGradient]: !!gradient,
        [s[`gradient-${gradient}`]]: !!gradient,
        [s.withDivider]: !!divider,
        [s.last]: last,
        [s.headingFullwidth]: headingFullwidth,
        [s.subheadingCols]: subheadingCols,
      },
      s[`direction${upperFirst(direction)}`],
      s[`align${upperFirst(align)}`],
      className
    )}
  >
    <Container className={s.container}>
      <div className={s.top}>
        {icon && (
          <div className={s.icon}>
            <Image src={icon} alt="illustration" width={60} height={60} />
          </div>
        )}
        <Heading level={2} className={s.heading}>
          {heading}
        </Heading>
        {!!subheading &&
          (typeof subheading === "object" && "multiline" in subheading ? (
            <div className={s.subheadingMultilined}>{subheading.content}</div>
          ) : (
            <p className={s.subheading}>{subheading}</p>
          ))}
        {buttons && <div className={s.buttons}>{buttons}</div>}
        {note && <p className={s.note}>{note}</p>}
      </div>
      <div className={s.content}>{children}</div>
    </Container>
  </section>
);
